/* 26.09.2026: переклад через Translate & Adapt. ADL("текст") повертає переклад
   з window.ADAPTIS_L (snippets/adaptis-l.liquid, ключі locales/uk.json
   adaptis_js.*), а без перекладу той самий український текст. */
var ADL = window.ADL || (window.ADL = function(s){ return window.ADAPTIS_L ? window.ADAPTIS_L(s) : s; });
/* Adaptis: верхній блок сторінки товару без конструктора. 25.09.2026.
   Розмітка в snippets/adaptis-product-top.liquid, стилі з adaptis-configurator.css.
   Галерея як у конструкторі: стрічка фото, яку гортає сам браузер (свайп на
   будь-якому телефоні), по краях копії для гортання по колу. Кнопки ведуть
   туди ж, куди й стара картка: кошик і його pop-up, вікно передзамовлення,
   вікно «Повідомити про наявність». */
(function () {
  "use strict";
  var root = document.getElementById("adaptisPm");
  if (!root) return;
  var P = {};
  try { P = JSON.parse(root.querySelector("[data-pm-json]").textContent); } catch (e) { return; }
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return [].slice.call(root.querySelectorAll(s)); };
  var money = function (c) { return Math.round(c / 100).toLocaleString("uk-UA").replace(/[\s  ,]/g, " ") + " ₴"; };
  var isRequest = root.dataset.request === "true", reqText = root.dataset.requestText || ADL("Передзамовлення"), isFrom = root.dataset.from === "true";

  /* ---------- галерея ---------- */
  var track = $("[data-pm-track]"), dots = $$("[data-pm-dots] .gdot"), thumbs = $$("[data-pm-thumbs] .gth");
  var imgs = track ? [].slice.call(track.children) : [], n = imgs.length, slide = 0, t = 0;
  var loop = n > 1;
  /* 26.09.2026: одне фото: без стрілок, крапок і мініатюр (CSS .gal--one). */
  if (track && n < 2) { var gbox = track.closest(".gal"); if (gbox) gbox.classList.add("gal--one"); }
  /* 26.09.2026: висота вікна для розміру галереї, як у конструкторі (--adx-vh). */
  (function () {
    var touch = window.matchMedia("(hover: none), (pointer: coarse)"), vw = 0;
    var setVh = function () {
      if (window.innerWidth === vw && touch.matches) return;
      vw = window.innerWidth;
      document.documentElement.style.setProperty("--adx-vh", window.innerHeight + "px");
    };
    setVh();
    window.addEventListener("resize", setVh);
  })();
  if (loop) {
    var first = imgs[0].cloneNode(true), last = imgs[n - 1].cloneNode(true);
    [first, last].forEach(function (c) { c.setAttribute("aria-hidden", "true"); c.removeAttribute("fetchpriority"); c.loading = "lazy"; });
    track.insertBefore(last, imgs[0]);
    track.appendChild(first);
  }
  var W = function () { return track ? Math.max(1, track.getBoundingClientRect().width) : 1; };
  var raw = function (i) { return loop ? i + 1 : i; };
  var to = function (r, smooth) { if (track) track.scrollTo({ left: r * W(), behavior: smooth ? "smooth" : "instant" }); };
  function mark() {
    dots.forEach(function (d, i) { d.classList.toggle("is-on", i === slide); });
    thumbs.forEach(function (b, i) { b.setAttribute("aria-pressed", String(i === slide)); });
  }
  /* 28.09.2026: після відкриття сторінки прокрутку стрічки хтось скидав у 0
     (у DOM у цей момент нічого не мінялось), а 0 у стрічці з петлею це копія
     останнього фото, тож обраним ставало останнє. Поки людина сама не гортала
     (дотик, миша, колесо, клавіші, стрілки, крапки, мініатюри, варіант),
     чужу прокрутку не вважаємо вибором: повертаємо обране фото. */
  var live = false;
  function go(i, smooth) { live = true; slide = i; mark(); to(raw(i), smooth); }
  function settle() {
    if (!track) return;
    var r = Math.round(track.scrollLeft / W()), i = r;
    if (!live) { if (r !== raw(slide)) to(raw(slide), false); return; }
    if (loop) {
      if (r <= 0) { i = n - 1; to(n, false); }
      else if (r >= n + 1) { i = 0; to(1, false); }
      else i = r - 1;
    }
    if (i !== slide && i >= 0 && i < n) { slide = i; mark(); }
  }
  function shift(d) {
    live = true;
    var next = (slide + d + n) % n;
    slide = next; mark();
    to(raw(next) + (d > 0 && next === 0 ? n : d < 0 && next === n - 1 ? -n : 0), true);
  }
  if (track && n) {
    ["pointerdown", "touchstart", "wheel", "keydown"].forEach(function (e) { track.addEventListener(e, function () { live = true; }, { passive: true }); });
    track.addEventListener("scroll", function () { clearTimeout(t); t = setTimeout(settle, 90); }, { passive: true });
    if ("onscrollend" in window) track.addEventListener("scrollend", function () { clearTimeout(t); settle(); });
    /* 26.09.2026: кадр вирівнюємо лише при зміні ширини стрічки (iPad шле
       resize під час прокрутки, і стрічка перескакувала). */
    var lastW = 0;
    var realign = function () { var w = track.clientWidth; if (!w || w === lastW) return; lastW = w; to(raw(slide), false); };
    window.addEventListener("resize", realign);
    if (window.ResizeObserver) new ResizeObserver(realign).observe(track);
    to(raw(0), false);
    dots.forEach(function (d, i) { d.addEventListener("click", function () { go(i, true); }); });
    thumbs.forEach(function (b, i) { b.addEventListener("click", function () { go(i, true); }); });
    var pv = $("[data-pm-prev]"), nx = $("[data-pm-next]");
    if (pv) pv.addEventListener("click", function () { shift(-1); });
    if (nx) nx.addEventListener("click", function () { shift(1); });
    /* 09.10.2026 (власник): клік по фото відкриває його на весь екран, як на сторінках з конструктором
       (спільне вікно AdaptisUI.photos з adaptis-configurator.js). */
    track.addEventListener("click", function (e) {
      if (e.target.tagName !== "IMG" || !window.AdaptisUI || !window.AdaptisUI.photos) return;
      var big = function (u) { return /[?&]width=\d+/.test(u) ? u.replace(/([?&]width=)\d+/, function (m, a) { return a + "2000"; }) : u; };
      window.AdaptisUI.photos(imgs.map(function (im) { return big(im.currentSrc || im.src); }), slide, function (i) { go(i, false); }, imgs.map(function (im) { return im.currentSrc || im.src; }));
    });
  }
  function goMedia(id) {
    if (!id) return;
    for (var i = 0; i < n; i++) if (String(imgs[i].getAttribute("data-media-id")) === String(id)) { go(i, true); return; }
  }

  /* ---------- варіанти ---------- */
  var variants = P.variants || [];
  /* Варіант від сервера (з ?variant= або цивільний перший доступний). */
  var cur = variants.filter(function (v) { return String(v.id) === (new URLSearchParams(location.search).get("variant") || root.dataset.variant); })[0]
    || variants.filter(function (v) { return v.available; })[0] || variants[0];
  var opts = cur ? (cur.options || []).slice() : [];
  var qty = 1;
  function find() {
    return variants.filter(function (v) { return (v.options || []).every(function (o, i) { return o === opts[i]; }); })[0] || null;
  }
  /* 25.09.2026: іконки моделей Starlink (як на картках каталогу) і поділ
     складеної опції «Колір (Модель)» на два рівні: колір кружечками з
     візерунком (центр фото варіанта) і корпус кнопками з іконками. */
  var MI = {mini:"https://cdn.shopify.com/s/files/1/0919/7977/6275/files/mini_5ae44135-0b97-4afe-b85e-6af07c84e371.svg?v=1772912622", gen2:"https://cdn.shopify.com/s/files/1/0919/7977/6275/files/gen2_1a5dc09f-4b69-4e0b-b697-18452cd619fc.svg?v=1772912622", gen3:"https://cdn.shopify.com/s/files/1/0919/7977/6275/files/gen3_9cc2fc01-8564-4d10-bb8f-7a668e8e2338.svg?v=1772912622", performance:"https://cdn.shopify.com/s/files/1/0919/7977/6275/files/performance.svg?v=1772912622"};
  function modelIcon(t) { t = String(t || "").toLowerCase(); if (/performance/.test(t)) return MI.performance; if (/gen\s*2/.test(t)) return MI.gen2; if (/gen\s*3|4x|standard/.test(t)) return MI.gen3; if (/mini/.test(t)) return MI.mini; return null; }
  var COMP = /^(.+?)\s*\(([^)]+)\)\s*$/, comps = [];
  (function setupOpts() {
    $$(".pm-opt").forEach(function (w) {
      var segs = [].slice.call(w.querySelectorAll(".seg[data-opt]"));
      if (!segs.length) return;
      var lab = w.querySelector(".pick__l"), ln = lab ? lab.textContent.toLowerCase() : "";
      var ms = segs.map(function (b) { return String(b.dataset.val).match(COMP); });
      var cols = [], mods = [];
      ms.forEach(function (m) { if (!m) return; if (cols.indexOf(m[1].trim()) < 0) cols.push(m[1].trim()); if (mods.indexOf(m[2].trim()) < 0) mods.push(m[2].trim()); });
      if (ms.every(Boolean) && cols.length > 1 && mods.length > 1) {
        var i = +segs[0].dataset.opt;
        var vals = segs.map(function (b) { return b.dataset.val; });
        var valOf = function (c, m) { return vals.filter(function (v) { var x = v.match(COMP); return x[1].trim() === c && x[2].trim() === m; })[0]; };
        /* 26.09.2026: візерунок кольору завжди з фото Gen3 (далі Gen2, далі будь-якого):
           фото Mini в каталозі повернуті й дрібніші, кружечки різнились. */
        var swVar = function (c) {
          var all = variants.filter(function (x) { var mm = String(x.options[i] || "").match(COMP); return mm && mm[1].trim() === c; });
          var by = function (re) { return all.filter(function (x) { return re.test(String(x.options[i]).match(COMP)[2]); })[0]; };
          return by(/gen\s*3|4x|standard/i) || by(/gen\s*2/i) || all[0];
        };
        var imgOf = function (c) { var v = swVar(c); var src = v && v.featured_image && (v.featured_image.src || v.featured_image); return src ? String(src) + (String(src).indexOf("?") > -1 ? "&" : "?") + "width=160" : ""; };
        var box = document.createElement("div");
        box.className = "pm-comp";
        box.innerHTML = ("<div class=\"colortop pm-opt\"><div class=\"colortop__h\">" + ADL("Колір:") + " <b></b></div><div class=\"sw-row\"></div></div>") +
          '<div class="pm-opt"><span class="pick__l"></span><div class="seg-row"></div></div>';
        box.querySelector(".pick__l").textContent = lab ? lab.textContent : "";
        var colBtns = cols.map(function (c) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "sw sw--img"; b.dataset.opt = i; b.dataset.part = c; b.title = c; b.setAttribute("aria-label", c);
          b.innerHTML = '<span class="sw__c"></span>';
          var im = imgOf(c); if (im) b.firstChild.style.backgroundImage = 'url("' + im + '")';
          /* 26.09.2026: фото варіантів Mini в каталозі повернуті на 90° відносно
             Gen2 і Gen3, тож візерунок із них повертаємо праворуч. */
          var sv = swVar(c);
          var sm = sv && String(sv.options[i] || "").match(COMP);
          if (sm && /mini/i.test(sm[2])) b.classList.add("sw--rot");
          box.querySelector(".sw-row").appendChild(b); return b;
        });
        var modBtns = mods.map(function (m) {
          var b = document.createElement("button");
          b.type = "button"; b.className = "seg"; b.dataset.opt = i; b.dataset.part = m;
          var ic = modelIcon(m);
          /* 26.09.2026: іконка маскою кольору тексту: на обраній кнопці синя. */
          b.innerHTML = (ic ? '<span class="seg__mi" aria-hidden="true" style="--mi:url(&quot;' + ic + '&quot;)"></span>' : "") + "<span></span>";
          b.lastChild.textContent = m;
          box.querySelector(".seg-row").appendChild(b); return b;
        });
        w.hidden = true;
        w.parentNode.insertBefore(box, w.nextSibling);
        comps.push({ i: i, valOf: valOf, cols: cols, mods: mods, colBtns: colBtns, modBtns: modBtns, name: box.querySelector(".colortop__h b") });
        return;
      }
      /* 26.09.2026: також «Генерація Starlink» (оптові закупки). */
      if (/модель|корпус|генерац|model|housing|generation|obudow|generacj/.test(ln)) segs.forEach(function (b) {
        var ic = modelIcon(b.dataset.val);
        if (!ic || b.querySelector(".seg__mi")) return;
        var t = b.textContent; b.innerHTML = '<span class="seg__mi" aria-hidden="true" style="--mi:url(&quot;' + ic + '&quot;)"></span><span></span>'; b.lastChild.textContent = t;
      });
    });
  })();
  /* Кожна кнопка складеної опції вибирає значення з поточною другою частиною. */
  function compPaint() {
    comps.forEach(function (c) {
      var m = String(opts[c.i] || "").match(COMP), cc = m ? m[1].trim() : c.cols[0], cmod = m ? m[2].trim() : c.mods[0];
      c.colBtns.forEach(function (b) { b.dataset.val = c.valOf(b.dataset.part, cmod) || c.valOf(b.dataset.part, c.mods[0]) || ""; });
      c.modBtns.forEach(function (b) { b.dataset.val = c.valOf(cc, b.dataset.part) || c.valOf(c.cols[0], b.dataset.part) || ""; });
      if (c.name) c.name.textContent = cc;
    });
  }
  function paintOpts() {
    compPaint();
    $$("[data-pm-sw]").forEach(function (w) {
      var nm = w.querySelector("[data-pm-swname]"), i = +w.getAttribute("data-pm-sw");
      var on = [].slice.call(w.querySelectorAll(".sw[data-opt]")).filter(function (b) { return b.dataset.val === opts[i]; })[0];
      if (nm) nm.textContent = on ? (on.dataset.label || on.dataset.val) : (opts[i] || "");
    });
    $$(".seg[data-opt], .sw[data-opt]").forEach(function (b) {
      var i = +b.dataset.opt, val = b.dataset.val;
      b.setAttribute("aria-pressed", String(opts[i] === val));
      /* Сіра кнопка: з іншими обраними опціями такого варіанта немає в наявності. */
      var test = opts.slice(); test[i] = val;
      var v = variants.filter(function (x) { return (x.options || []).every(function (o, k) { return o === test[k]; }); })[0];
      b.classList.toggle("is-na", !v || !v.available);
    });
    $$("select[data-opt]").forEach(function (s) { s.value = opts[+s.dataset.opt]; });
    $$("[data-pm-purpose]").forEach(function (c) { c.checked = opts[+c.dataset.opt] === c.dataset.on; });
  }
  /* 25.09.2026: «В колір авто»: поле коду фарби під кольорами, тексти ті самі,
     що в квізі; код іде властивістю позиції «Код кольору кузова», як із
     конструктора. */
  var paintCode = "";
  var isPaint = function (v) { return /premium|авто| car|samochod/i.test(String(v || "")); };
  function paintIdx() {
    var w = $$("[data-pm-sw]").filter(function (x) { return [].slice.call(x.querySelectorAll(".sw[data-opt]")).some(function (b) { return isPaint(b.dataset.val); }); })[0];
    return w ? +w.getAttribute("data-pm-sw") : -1;
  }
  function paintField() {
    var i = paintIdx();
    if (i < 0) return;
    var w = $('[data-pm-sw="' + i + '"]'), f = w.querySelector(".pm-paint");
    var on = isPaint(opts[i]);
    if (on && !f) {
      f = document.createElement("div");
      f.className = "field pm-paint";
      f.innerHTML = ("<label for=\"pmPaint\">" + ADL("Код кольору кузова, якщо знаєте") + "</label>") +
        ("<input id=\"pmPaint\" type=\"text\" maxlength=\"40\" autocomplete=\"off\" placeholder=\"" + ADL("Наприклад, 040 або NH731P").replace(/"/g, "&quot;") + "\">") +
        ("<p class=\"pm-paint__h\">" + ADL("Фарбуємо корпус у колір вашого авто. Код є в сервісній книжці або на табличці під капотом. Якщо не знаєте, залиште це поле порожнім.") + "</p>");
      var inp = f.querySelector("input");
      inp.value = paintCode;
      inp.addEventListener("input", function () { paintCode = inp.value; });
      w.appendChild(f);
    } else if (!on && f) f.remove();
  }
  var cartIds = null;
  function inCartNow() { return !!(cartIds && cur && cartIds[cur.id]); }
  function amInCart() { var a = amVar(); return !!(cartIds && a && cartIds[a.id]); }
  function readCart(c) {
    cartIds = {};
    ((c && c.items) || []).forEach(function (i) { cartIds[i.variant_id] = true; });
  }
  function loadCart() {
    var CP = window.AdaptisCartPop;
    var pr = CP ? CP.refresh() : fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
    return pr.then(function (c) { readCart(c); paint(); }).catch(function () {});
  }
  document.addEventListener("cart:update", function (e) {
    var c = e && e.detail && e.detail.resource;
    if (c && c.items) { readCart(c); paint(); } else loadCart();
  });
  /* ---------- Adaptis Amulet на сторінці готового набору ---------- */
  /* 28.09.2026 (власник): картка «Інтернет під час повітряних тривог» під
     блоком покупки (snippets/adaptis-product-top.liquid, лише набори в
     наявності). Нічого не обрано наперед; ціна йде за призначенням набору;
     «Купити» кладе набір і Amulet окремим рядком (набір не розбиваємо). */
  var amBox = $("#pmAmulet"), amYes = false, amSeen = false;
  var isDef = function (v) { return !!v && (v.options || []).some(function (o) { return /Оборон|Defen|Obronn/i.test(String(o)); }); };
  function amVar() {
    if (!amBox) return null;
    var d = isDef(cur);
    return { id: +(d ? amBox.dataset.defId : amBox.dataset.civId), price: +(d ? amBox.dataset.defPrice : amBox.dataset.civPrice) };
  }
  /* Обраний Amulet рахується, лише поки картку видно (набір у наявності). */
  function amOn() { return !!(amBox && !amBox.hidden && amYes); }
  function amPaint() {
    if (!amBox) return;
    amBox.hidden = !cur || !cur.available;
    var a = amVar(), pe = amBox.querySelector("[data-pm-amp]");
    if (pe && a) pe.textContent = "+ " + money(a.price);
    [].forEach.call(amBox.querySelectorAll("[data-pm-am]"), function (b) {
      var on = b.dataset.pmAm === "yes" ? amYes : amYes === false && b.dataset.pmPicked === "1";
      b.setAttribute("aria-pressed", String(on));
    });
    if (!amBox.hidden && !amSeen && window.AdaptisSrc) { amSeen = true; window.AdaptisSrc.track("kit_amulet_view", { once: true }); }
  }
  var AM_ICONS = {
    wifi: '<path d="M2 8.8C7.6 4 16.4 4 22 8.8"/><path d="M5.2 12.3C9 9.2 15 9.2 18.8 12.3"/><path d="M8.5 15.7C10.6 14.1 13.4 14.1 15.5 15.7"/><path d="M12 19.5H12.01"/>',
    chip: '<rect x="6" y="6" width="12" height="12" rx="2.5"/><path d="M9.5 10H14.5V14H9.5Z"/><path d="M9 2.5V6M15 2.5V6M9 18V21.5M15 18V21.5M2.5 9H6M2.5 15H6M18 9H21.5M18 15H21.5"/>',
    check: '<circle cx="12" cy="12" r="10"/><path d="M8 12.5L10.5 15L16 9.5"/>',
    gpsoff: '<path d="M9.2 3A8.6 8.6 0 0 1 20.3 7.4C21.4 10 21 12.3 19.8 14.4"/><path d="M17.2 17.6C16 18.9 14.8 20.1 13.6 21.4C13.2 21.8 12.6 22 12 22C11.4 22 10.8 21.8 10.4 21.4C6.4 17.6 1.1 13.4 3.7 7.4"/><path d="M12 14.5A3.5 3.5 0 0 1 8.5 11"/><path d="M3 3L21 21"/>'
  };
  function amInfo() {
    if (!window.AdaptisUI) return;
    var A = window.ADAPTIS_ASSETS || {};
    /* Ті самі факти, що у вікні конструктора (крок amulet у adaptis-cfg-*.js). */
    window.AdaptisUI.info({ title: "Adaptis Amulet", img: A.amuletInfo || A.amulet,
      facts: [
        { i: "wifi", t: ADL("Модифікація термінала. Starlink працює під час повітряних тривог"), main: true },
        { i: "check", t: ADL("Встановлюється на будь-який Starlink без змін зовнішнього вигляду") }
      ],
      warn: { i: "gpsoff", t: ADL("Amulet тримає інтернет, а не навігацію: GPS-навігація під час тривог не працює") } },
      function (n) { return '<svg class="cfgcard__fi" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (AM_ICONS[n] || "") + "</svg>"; });
  }

  function paint() {
    var v = cur;
    var am = amOn() ? amVar().price : 0;
    var price = (v ? v.price : P.price) + am, old = v && v.compare_at_price > v.price ? v.compare_at_price + am : 0;
    var pt = (isFrom ? (ADL("від") + " ") : "") + money(price);
    var pe = $("[data-pm-price]"), oe = $("[data-pm-old]"), be = $("[data-pm-barprice]"), pa = $("[data-pm-parts]");
    if (pe) pe.textContent = pt;
    if (be) be.textContent = pt;
    if (oe) { oe.hidden = !old; oe.textContent = old ? money(old) : ""; }
    if (pa) pa.textContent = (ADL("До 3 платежів, від") + " ") + money(Math.ceil(price / 300) * 100) + (" " + ADL("на місяць"));
    var na = !v || !v.available;
    /* З обраним Amulet «В кошику» лише коли там і набір, і Amulet. */
    var done = !na && !isRequest && inCartNow() && (!amOn() || amInCart());
    $$("[data-pm-buy]").forEach(function (b) {
      /* 25.09.2026: обраний варіант уже в кошику: «В кошику», клік відкриває кошик. */
      if (done) b.innerHTML = ("<span class=\"buy__cart\" aria-hidden=\"true\"><svg viewBox=\"0 0 20 20\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686\"/></svg></span>" + ADL("В кошику"));
      else b.textContent = na ? ADL("Немає в наявності") : isRequest ? reqText : ADL("Купити");
      b.classList.toggle("buy--done", done);
      b.classList.toggle("is-na", na);
      b.disabled = false;
    });
    var q = $("[data-pm-qty]");
    if (q) q.textContent = qty;
    paintOpts();
    paintField();
    amPaint();
  }
  function pick(i, val) {
    opts[i] = val;
    var v = find();
    if (!v) {
      /* Такої комбінації немає: беремо перший варіант з цим значенням. */
      v = variants.filter(function (x) { return x.options[i] === val && x.available; })[0] || variants.filter(function (x) { return x.options[i] === val; })[0];
      if (v) opts = v.options.slice();
    }
    cur = v;
    if (v) {
      try { var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u); } catch (e) {}
      if (v.featured_media) goMedia(v.featured_media.id);
    }
    paint();
  }
  root.addEventListener("click", function (e) {
    /* 26.09.2026: «Не знаю» про тип даху: варіант «Сталь» (базова ціна), модель
       авто йде в передзамовлення назвою варіанта; менеджер уточнить дах. */
    var ru = e.target.closest("[data-roof-unknown]");
    if (ru) {
      var ri = +ru.dataset.roofUnknown;
      var steel = $$('.seg[data-opt="' + ri + '"]').map(function (x) { return x.dataset.val; }).filter(function (x) { return /сталь|steel|stal/i.test(x); })[0];
      if (steel) pick(ri, steel);
      roofUnknown = true; roofMark();
      var f = $("[data-pm-car]"); if (f) f.hidden = false;
      return;
    }
    var b = e.target.closest(".seg[data-opt], .sw[data-opt]");
    if (b) {
      if (roofUnknown && $('[data-roof-unknown="' + b.dataset.opt + '"]')) { roofUnknown = false; var f2 = $("[data-pm-car]"); if (f2) f2.hidden = true; }
      pick(+b.dataset.opt, b.dataset.val); roofMark(); return;
    }
    var q = e.target.closest("[data-pm-qd]");
    if (q) { qty = Math.max(1, Math.min(99, qty + (+q.dataset.pmQd))); paint(); return; }
    var ab = e.target.closest("[data-pm-am]");
    if (ab) {
      amYes = ab.dataset.pmAm === "yes";
      [].forEach.call(amBox.querySelectorAll("[data-pm-am]"), function (x) { x.dataset.pmPicked = x === ab ? "1" : ""; });
      if (amYes && window.AdaptisSrc) window.AdaptisSrc.track("kit_amulet_pick");
      paint(); return;
    }
    if (e.target.closest("[data-pm-aminfo]")) { amInfo(); return; }
    var buy = e.target.closest("[data-pm-buy]");
    if (buy) act(buy);
  });
  root.addEventListener("change", function (e) {
    var s = e.target;
    if (s.matches("select[data-opt]")) pick(+s.dataset.opt, s.value);
    else if (s.matches("[data-pm-purpose]")) pick(+s.dataset.opt, s.checked ? s.dataset.on : s.dataset.off);
  });

  var roofUnknown = false;
  function roofMark() {
    var u = $("[data-roof-unknown]");
    if (!u) return;
    u.setAttribute("aria-pressed", String(roofUnknown));
    if (roofUnknown) $$('.seg[data-opt="' + u.dataset.roofUnknown + '"]').forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
  }
  /* ---------- кнопка ---------- */
  function act(btn) {
    var v = cur;
    /* 26.09.2026: «В кошику» веде одразу в кошик, без вікна (власник). */
    var withAm = amOn() && !amInCart(), a = amVar();
    if (inCartNow() && !withAm) { window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart"; return; }
    if (!v || !v.available) {
      if (window.AdaptisNotify && typeof window.AdaptisNotify.open === "function") window.AdaptisNotify.open(P.title, String(P.id), P.handle);
      return;
    }
    if (isRequest) {
      document.dispatchEvent(new CustomEvent("adaptis:request-product-open", { bubbles: true, detail: {
        productId: String(P.id), productTitle: P.title, handle: P.handle,
        variantId: String(v.id), variantTitle: roofUnknown
          ? ADL("Тип даху: не знаю") + (($("#pmCar") || {}).value ? (ADL(". Модель авто:") + " ") + $("#pmCar").value.trim() : "")
          : (v.title !== "Default Title" ? v.title : "")
      } }));
      return;
    }
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    var keep = btn.textContent;
    $$("[data-pm-buy]").forEach(function (b) { b.disabled = true; b.textContent = ADL("Додаємо…"); });
    var adding = fetch(rootUrl + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [(function () {
        var it = { id: v.id, quantity: qty }, pi = paintIdx();
        if (pi >= 0 && isPaint(opts[pi])) it.properties = { "Код кольору кузова": paintCode.trim() || "уточнити з менеджером" };
        return it;
      })()].filter(function () { return !inCartNow(); })
        /* Amulet по одному на кожен набір. */
        .concat(withAm ? [{ id: a.id, quantity: qty }] : []) }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || ADL("Помилка")); return d; }); });
    if (withAm) adding.then(function () { if (window.AdaptisSrc) window.AdaptisSrc.track("kit_amulet_add", { value: a.price * qty / 100 }); }, function () {});
    var CP = window.AdaptisCartPop;
    if (!CP) {
      adding.then(function () { location.href = rootUrl + "cart"; }, function (err) {
        paint();
        $$("[data-pm-buy]").forEach(function (b) { b.textContent = keep; });
        alert(err && err.message || ADL("Не вдалося додати в кошик"));
      });
      return;
    }
    /* 28.09.2026: вікно «Додано в кошик» одразу, з фото, назвою й ціною зі
       сторінки; кошик і допродаж домальовуються після відповіді Shopify.
       Відмову (немає в наявності, ліміт) пояснює саме вікно. */
    var shown = imgs[slide], pic = shown && (shown.tagName === "IMG" ? shown : shown.querySelector("img"));
    CP.open({ productId: String(P.id), productHandle: P.handle, adding: adding,
      preview: [{ variant_id: v.id, product_id: P.id, handle: P.handle,
        title: P.title + (v.title && v.title !== "Default Title" ? ", " + v.title : ""),
        image_exact: pic ? (pic.currentSrc || pic.src) : "", line_price: v.price * qty, quantity: qty }]
        .filter(function () { return !inCartNow(); })
        .concat(withAm ? [{ variant_id: a.id, product_id: +amBox.dataset.pid, handle: amBox.dataset.handle, title: "Adaptis Amulet",
          image_exact: amBox.dataset.img || "", line_price: a.price * qty, quantity: qty }] : []),
      onShown: function () {
        var c = CP.cart;
        if (c) { readCart(c); CP.announce(c); }
        paint();
      },
      onFail: function () {
        paint();
      } });
  }

  /* ---------- нижня панель ---------- */
  var bar = $("[data-pm-bar]"), box = $(".buybox");
  function showBar(on) {
    if (!bar) return;
    bar.classList.toggle("is-on", on);
    bar.setAttribute("aria-hidden", String(!on));
    document.documentElement.classList.toggle("adaptis-bar-on", on);
    document.body.classList.toggle("has-bar", on);
  }
  if (bar && box && typeof IntersectionObserver !== "undefined") {
    new IntersectionObserver(function (en) { showBar(!en[0].isIntersecting); }, { rootMargin: "-70px 0px 0px 0px", threshold: 0 }).observe(box);
  } else showBar(true);

  paint();
  loadCart();
  /* 27.09.2026: та сама смуга розділів під шапкою, що на сторінках
     конструктора (модуль AdaptisPageNav у adaptis-configurator.js). */
  if (window.AdaptisPageNav) window.AdaptisPageNav(root);
  /* 25.09.2026: «Разом із цим купують» заздалегідь, щоб вікно кошика
     відкривалось одразу після «Купити». */
  (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () {
    if (window.AdaptisCartPop && window.AdaptisCartPop.prefetch) window.AdaptisCartPop.prefetch({ productId: String(P.id), productHandle: P.handle });
  }, { timeout: 3000 });
})();
